module.exports = __webpack_public_path__ + "static/media/000004.05ef5d6b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/000004.mp3
// module id = 827
// module chunks = 0